import Vue from 'vue'
import template from './index.pug'

// @vue/component
export default Vue.extend({
  name: 'map-autgc',
  template: template(),
  components: {
  },
  data() {
    return {
      urlMap: 'https://autgc.maps.arcgis.com/apps/webappviewer/index.html?id=1171a90c8f18443bbc0b148dad86bb2c',
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
})
